import { render, staticRenderFns } from "./wenben.vue?vue&type=template&id=db5f1daa&scoped=true"
import script from "./wenben.vue?vue&type=script&lang=ts"
export * from "./wenben.vue?vue&type=script&lang=ts"
import style0 from "./wenben.vue?vue&type=style&index=0&id=db5f1daa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5f1daa",
  null
  
)

export default component.exports